import { Component, Input } from '@angular/core';
import { AvailableQuestion, SecretQuestion } from '@models/two-fa.models';

@Component({
	selector: 'set-up-questions',
	template: require('./set-up-questions.component.html'),
	styles: [require('./set-up-questions.component.scss')]
})
export class SetUpQuestionsComponent {
	@Input() submittedQuestions: Array<SecretQuestion>;
	@Input() availableQuestions: Array<AvailableQuestion>;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/set-up-questions.component.ts